var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 56.6667V13.3334H6.6665V56.6667H33.3332V63.3334H26.6665V66.6667H53.3332V63.3334H46.6665V56.6667H73.3332ZM9.99984 16.6667H69.9998V53.3334H9.99984V16.6667ZM43.3332 63.3334H36.6665V56.6667H43.3332V63.3334ZM28.3332 45H13.3332V30H28.3332V45ZM16.6665 41.6667H24.9998V33.3334H16.6665V41.6667ZM48.3332 45H31.6665V30H48.3332V45ZM34.9998 41.6667H44.9998V33.3334H34.9998V41.6667ZM66.6665 45H51.6665V30H66.6665V45ZM54.9998 41.6667H63.3332V33.3334H54.9998V41.6667ZM39.9998 23.3334H13.3332V20H39.9998V23.3334ZM66.6665 23.3334H63.3332V20H66.6665V23.3334ZM59.9998 23.3334H56.6665V20H59.9998V23.3334Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDashboard);
export default __webpack_public_path__ + "static/media/desktop-dashboard.35b189c5d9ca20db9c21404e44351ab5.svg";
export { ForwardRef as ReactComponent };